module.exports = __webpack_public_path__ + "img/9788960172807.22461408.jpg";